import React from 'react';
import {useSelector} from 'react-redux';
import {IonActionSheet} from '@ionic/react';
import {useHistory, useLocation} from 'react-router-dom';

import {Course, Store} from 'src/types/store';

import UnstyledButton from 'src/components/unstyled-button';
import Icon from 'shared/components/icon';
import SchoolHeader from './school-header';
import EmptyInstitutionSection from './empty-institution-section';
import SchoolTable from './school-table';

import styles from './school-section.module.scss';

interface Props {
  institutionId: string;
  courseGroups: Record<string, Course[]>;
  classYear: string;
  onAddClick: () => void;
}

const MobileSchoolSection = ({institutionId, courseGroups, classYear, onAddClick}: Props) => {
  const history = useHistory();
  const {pathname} = useLocation();
  const institution = useSelector((state: Store) => state.institutions[institutionId]);
  const coursesByGradeSettings = Object.keys(courseGroups);
  const editKey = `open-edit-${institution._id}-${classYear}`;

  if (!institution) return null;

  if (coursesByGradeSettings.length === 1 && Object.values(courseGroups)[0]?.length === 0) {
    return (
      <EmptyInstitutionSection
        key={institution._id}
        name={institution.name}
        classYear={classYear}
        onAddClick={onAddClick}
      />
    );
  }

  return (
    <>
      <div className={styles.mobileHeader}>
        <SchoolHeader>{institution.name}</SchoolHeader>
        <UnstyledButton id={editKey} type="button">
          <Icon iconType="ellipsis-h" className={styles.mobileEllipsis} />
        </UnstyledButton>
      </div>

      <IonActionSheet
        trigger={editKey}
        header={institution.name}
        subHeader={`${classYear} Year`}
        buttons={[
          {
            text: 'Edit School',
            handler: () =>
              history.replace({
                pathname: `${pathname}/school/${institutionId}`,
                state: {skipScrolling: true},
              }),
          },
          {text: 'Edit Courses', handler: onAddClick},
          {text: 'Cancel', role: 'cancel', data: {action: 'cancel'}},
        ]}
      />

      <SchoolTable schoolName={institution.name} courseGroups={courseGroups} />
    </>
  );
};

export default MobileSchoolSection;
